<template>
  <div class="app_container">
    <!--操作栏-->
    <div class="filter_container">
      <butn
        btntype="primary"
        title="新增"
        iconName="el-icon-plus"
        @click.native="handleAdd"
        v-permission="'creditRule:save'"
      ></butn>
    </div>
    <Tables :data="creditRuleList" @editRule="editRule" @deleteRule="deleteRule" @displayCr="displayCr"/>
    <!-- 新增、编辑 -->
    <Curd ref="curdModal" @refresh="search"/>
  </div>
</template>
<script>
import butn from "@/components/button/index";
import Tables from "./table.js";
import Curd from "./curd";
import {
  creditRuleDeleteNew,
  creditRuleDisplayNew,
  creditRuleListNew
} from "@/api/creditRule";

export default {
  name: "creditRule",
  components: { butn, Tables, Curd },
  data() {
    return {
      size: "small",
      creditRuleList: [],
    };
  },
  methods: {
    
    getRuleList() {
      creditRuleListNew().then(({code, data} )=> {
        if (code === 0) {
          this.creditRuleList = data;
        }
      });
    },
    handleAdd() {
      this.$refs.curdModal.addCr()
    },
    search() {
      this.getRuleList();
    },
    editRule(params) {
      this.$refs.curdModal.updateCr(params)
    },
    deleteRule(params) {
      this.$confirm(`确认删除学时规则吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          creditRuleDeleteNew(params).then(res => {
            if (!res || res.code !== 0) return;
            this.search();
          });
        })
        .catch(() => {});
    },
    displayCr(status, params, msg) {
      this.$confirm(`确认` + msg + `学时规则吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          creditRuleDisplayNew(params).then(res => {
            if (!res || res.code !== 0) return;
            this.search();
          });
        })
        .catch(() => {});
    },
  },
  created() {
    this.getRuleList();
  },
  beforeDestroy() {
  }
};
</script>
